var r=function(){for(var r=[],n=0;n<arguments.length;n++)r[n]=arguments[n];if(!(r.length<=4))return"0px";var t=function(r){return"number"==typeof r?4*r+"px":r};if(0===r.length){return t(1)}return r.map(t).join(" ")};export{r as spacing};
